import React, { useEffect } from "react";
import { connect } from "react-redux";
import { saveUser } from "../../redux/actions/userAction";
import { saveProducts } from "../../redux/actions/productsAction";
import ImageMapper from "react-img-mapper";
import { useHistory } from "react-router-dom";
import HeroSliderOneNew from "../../backconfig/banner/HeroSliderOneNew";
import BannerClassicScroll from "./BannerClassicScroll";
import { useState } from "react";
import BannerAmazonStyle from "./BannerAmazonStyle";
import axios from "axios";

const HomeBanner = (props) => {
  const history = useHistory();
  const { userData, bannerProps, forTestOnly, products } = props;
  const [allBanners, setAllBanners] = useState([]);
  const endPointBaseUrl = global.endpoint;

  const [bannerNow, setBannerNow] = useState(props.banner);

  useEffect(() => {
    setBannerNow(props.banner);
  }, [forTestOnly, bannerProps]);

  const getBanner = () => {
    const _props = {
      heroSliderData: bannerNow.bannerImageScroll,
      forTestOnly,
      userData,
    };
    //return (<BannerAmazonStyle {..._props} products = {products}/>);

    switch (bannerNow.bannerType) {
      case 1:
        return <HeroSliderOneNew {..._props} />;
      case 2:
        return <BannerClassicScroll {..._props} />;
      default:
        return null;
    }
  };
  const banner = () => {
    if (bannerNow) {
      const n = getBanner();
      if (n) return n;
      else if (forTestOnly) return null;
    }
    return null;
  };
  /*<!-- Image Map Generated by http://www.image-map.net/ -->
<img src="newbanner1conprezzo.png" usemap="#image-map">

<map name="image-map">
    <area target="" alt="" title="" href="" coords="1,3,1578,1,
                                                1465,534,1,534" shape="poly">
    <area target="" alt="" title="" href="" coords="1,539,1465,537, 1379,
                                                953,1,953,1,762" shape="poly">
    <area target="" alt="" title="" href="" coords=
        "2248,954,1495,956,1580,530, 1580,
        23,1680,21,1686,-1,2248,3" shape="poly">
</map>
*/

  return banner();
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    products: state.productData.products,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
    saveProducts: (products, addToast) => {
      dispatch(saveProducts(products, addToast));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(HomeBanner);
